import { AxiosInstance, AxiosResponse } from 'axios';
import { Summary } from 'prom-client';
import { getMetric } from '@utils/prometheus-client';

export const ObservePromAPILatency = (axios: AxiosInstance): AxiosInstance => {
    if (!axios || typeof axios.request !== 'function') {
        return axios;
    }

    const summary = getMetric<Summary>('api_request_latency');
    if (!summary) {
        return axios;
    }

    const startedAt = Date.now();

    const observeFn = (resp: AxiosResponse): AxiosResponse => {
        try {
            const url = new URL(resp.config.url, resp.config.baseURL || 'https://example.com');
            const elapsedMs = Date.now() - startedAt;
            summary.labels(url.hostname, url.pathname).observe(elapsedMs);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('⚠️ ObservePromAPILatency error:', error);
        }

        return resp;
    };

    axios.interceptors.response.use(observeFn);

    return axios;
};
